module.exports = __webpack_public_path__ + "img/speaker-TemurKetsbaia.d2df2889.png";